import CONSTANT from 'modules/constant'
import type { PartialUserMemberProps } from 'modules/partial'
import type { PaginationProps, UserMember, UserMemberDetail } from 'modules/types'
import { API, headers } from './api'

const userMemberApi = API.injectEndpoints({
    endpoints: (builder) => ({
        getUsers: builder.query<PaginationProps<UserMember>, PartialUserMemberProps>({
            query: (payload) => {
                const body = new FormData()
                body.append('start', payload.start.toString())
                body.append('length', payload.length.toString())
                body.append('search[value]', payload.search?.value?.toString() || '')
                body.append('min-created-date', (payload?.minCreatedDate as string) || '')
                body.append('max-created-date', (payload?.maxCreatedDate as string) || '')

                body.append('min-created-date', (payload?.minCreatedDate as string) || '')
                body.append('max-created-date', (payload?.maxCreatedDate as string) || '')
                // body.append("member-tier", (payload?.memberTier as string) || '')
                // body.append("latest-region", (payload?.latestRegion as string) || '')
                body.append('status', (payload?.status as string) || '')
                // body.append("idm-status", (payload?.idmStatus as string) || '')
                body.append('min-birthdate', (payload?.minBirthdate as string) || '')
                body.append('max-birthdate', (payload?.maxBirthdate as string) || '')
                // body.append("city-id", (payload?.cityId as string) || '')
                // body.append("province-id", (payload?.provinceId as string) || '')
                // body.append("car-model-id", (payload?.carModelId as string) || '')
                // body.append("os-name", (payload?.osName as string) || '')
                body.append('min-last-login', (payload?.minLastLogin as string) || '')
                body.append('max-last-login', (payload?.maxLastLogin as string) || '')
                // body.append('min-signup', (payload?.minSignup as string) || '')
                // body.append('max-signup', (payload?.maxSignup as string) || '')
                body.append('min-coins', (payload?.minCoins as string) || '')
                body.append('max-coins', (payload?.maxCoins as string) || '')
                body.append('field', CONSTANT.DEFAULT_USER_MEMBER_FIELD.join(','))
                body.append('vin', (payload?.vin as string) || '')

                CONSTANT.DEFAULT_USER_MEMBER_FIELD.forEach((field) => {
                    // body.append(
                    //   `columns[${CONSTANT.DEFAULT_USER_MEMBER_FIELD.indexOf(field)}][search][value]`,
                    //   payload.search?.value || ''
                    // )
                    body.append(
                        `columns[${CONSTANT.DEFAULT_USER_MEMBER_FIELD.indexOf(field)}][searchable]`,
                        'true'
                    )
                    body.append(`columns[${CONSTANT.DEFAULT_USER_MEMBER_FIELD.indexOf(field)}][data]`, field)
                    body.append(`columns[${CONSTANT.DEFAULT_USER_MEMBER_FIELD.indexOf(field)}][name]`, field)
                })
                // body.append('order[0][column]', '1')
                // body.append('order[0][dir]', 'desc')

                return {
                    url: CONSTANT.URL_USER_LIST_MEMBER,
                    method: 'POST',
                    headers: headers({ useContentType: false }),
                    body: body,
                    formData: true
                }
            }
        }),
        getUserDetail: builder.query<UserMemberDetail, string>({
            query: (id) => ({
                url: CONSTANT.URL_USER_DETAIL_MEMBER.replace('{id}', id.toString()),
                method: 'GET',
                headers: headers()
            }),
            providesTags: ['UserDetail']
        })
    })
})

export const { useGetUsersQuery, useGetUserDetailQuery } = userMemberApi
